import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";


export class TutorialKind extends Cloneable {
    static CUSTOM = new TutorialKind(0, "CUSTOM");
    static EXPLAINER = new TutorialKind(1, "EXPLAINER");
    static ARROW = new TutorialKind(2, "ARROW");//+
    static FIREFLY = new TutorialKind(3, "FIREFLY");
    static CAMERA = new TutorialKind(4, "CAMERA");//+
    static REMOVE = new TutorialKind(5, "REMOVE");
    static MERGE = new TutorialKind(6, "MERGE");//+
    static BLOCK_GRID = new TutorialKind(7, "BLOCK_GRID");//+
    static TALK_DIALOG = new TutorialKind(8, "TALK_DIALOG");
    static TELEPORTATION = new TutorialKind(9, "TELEPORTATION");
    static TALK_WITH_ARROW = new TutorialKind(10, "TALK_WITH_ARROW");

    static _values = [
        this.CUSTOM,
        this.EXPLAINER,
        this.ARROW,
        this.FIREFLY,
        this.CAMERA,
        this.REMOVE,
        this.MERGE,
        this.BLOCK_GRID,
        this.TALK_DIALOG,
        this.TELEPORTATION,
        this.TALK_WITH_ARROW
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TutorialKind.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof TutorialKind) {
            return TutorialKind._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "CUSTOM") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof TutorialKind) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TutorialKind());
        } else if (target instanceof TutorialKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TutorialKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});